<div
  class="concert-item-image-main row"
  [routerLink]="['/concert/', concert.SEOURL]"
>
  <div class="concert-item-image col-12">
    <img [src]="concert.PRODUCTURL" [alt]="concert.SUBTICKETNAME" />
  </div>

  <h2 class="ticket-title">{{ concert.SUBTICKETNAME }}</h2>

  <div
    class="col-12 ticket-detail"
    *ngIf="concert?.SUBCONCERTS[0].TICKETDETAIL"
    [innerHtml]="spliceText(concert?.SUBCONCERTS[0].TICKETDETAIL) | safe"
  ></div>
  <div
    class="col-12 ticket-detail"
    *ngIf="!concert?.SUBCONCERTS[0].TICKETDETAIL"
  >
    &nbsp;
  </div>

  <div class="ticket-btn">{{ "Buy" | translate | async }}</div>
</div>
